import ControlProps from '../../../mixins/ControlProps';
import { DatePickerProperty } from '../enums';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';

const DatePickerProps = {
  props: {
    ...ControlProps.props,
    [DatePickerProperty.FillType]: InputProps.props[InputProperty.FillType],
    [DatePickerProperty.MinDate]: {
      default: null,
      type: [Date, String, Number],
    },
    [DatePickerProperty.MaxDate]: {
      default: null,
      type: [Date, String, Number],
    },
    [DatePickerProperty.DisabledDateRange]: {
      default: () => [],
      type: Array,
    },
    [DatePickerProperty.DisabledWeekdays]: {
      default: () => [],
      type: Array,
    },
    [DatePickerProperty.Holidays]: {
      default: () => [],
      type: Array,
    },
  },
};

export default DatePickerProps;
